import React, { useContext, useEffect, useState } from "react";
import { ThemeContext } from "../../../context/ThemeContext";
import "./style.css";
import LOGO from "../../../images/logo.png";
import LOGO_COLLAPSED from "../../../images/logo.png";

export function NavMenuToggle(callback) {
  const mainwrapper = document.querySelector("#main-wrapper");
  if (!mainwrapper) return;

  const isNowCollapsed = mainwrapper.classList.toggle("menu-toggle");
  callback?.(isNowCollapsed);
}

const NavHader = () => {
  const [toggle, setToggle] = useState(false);
  const { navigationHader, background } = useContext(ThemeContext);

  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const mainwrapper = document.querySelector("#main-wrapper");

    const updateState = () => {
      const isCollapsed = mainwrapper?.classList.contains("menu-toggle");
      const shouldCollapse = Boolean(isCollapsed) || window.innerWidth < 1024;
      setIsSidebarCollapsed(shouldCollapse);
      setToggle(Boolean(isCollapsed));
      setScreenWidth(window.innerWidth);
    };

    updateState();
    window.addEventListener("resize", updateState);

    let observer;
    if (mainwrapper) {
      observer = new MutationObserver(() => {
        updateState();
      });
      observer.observe(mainwrapper, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }

    return () => {
      window.removeEventListener("resize", updateState);
      observer?.disconnect();
    };
  }, []);

  const showCollapsedLogo = screenWidth < 1024 || isSidebarCollapsed;
  const isDarkOrColored =
    background?.value === "dark" || (navigationHader && navigationHader !== "color_1");

  return (
    <div className="nav-header" style={{ zIndex: 11 }}>
      <div
        className="brand-logo target-div"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 10px",
          height: "100%",
          width: "100%",
          overflow: "hidden",
          cursor: "default",
          userSelect: "none",
        }}
      >
        <img
          style={{
            objectFit: "contain",
            width: "auto",
            maxWidth: showCollapsedLogo ? "55px" : "180px",
            height: showCollapsedLogo ? "55px" : "70px",
            maxHeight: "72px",
            flexShrink: 0,
            transition: "all 0.2s ease",
            pointerEvents: "none",
            userSelect: "none",
          }}
          src={showCollapsedLogo ? LOGO_COLLAPSED : LOGO}
          alt="MCD Delhi Mini League Logo"
        />
      </div>

      <div
        className="nav-control"
        onClick={() => {
          NavMenuToggle((collapsed) => {
            setIsSidebarCollapsed(collapsed);
            setToggle(collapsed);
          });
        }}
      >
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;
